import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const WordpressLogo = ({
  color = "#003C56",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Wordpress Logo</title>
    <path
      fill="currentColor"
      d="M8.468 64c0 22.006 12.8 40.96 31.31 49.969L13.293 41.403A55.336 55.336 0 008.468 64zM64 119.532c6.45 0 12.652-1.132 18.462-3.15l-.394-.739-17.083-46.77-16.64 48.395c4.923 1.477 10.19 2.264 15.655 2.264zm7.63-81.575l20.087 59.717 5.563-18.51c2.363-7.68 4.185-13.195 4.185-17.97 0-6.893-2.462-11.619-4.53-15.262-2.855-4.627-5.464-8.517-5.464-13.046 0-5.12 3.84-9.846 9.354-9.846h.689A55.336 55.336 0 0064 8.468a55.483 55.483 0 00-46.375 25.009l3.544.098c5.81 0 14.77-.738 14.77-.738 3.052-.148 3.396 4.234.393 4.578 0 0-3.003.394-6.4.542l20.283 60.16 12.16-36.43-8.664-23.73a99.058 99.058 0 01-5.81-.492c-3.003-.197-2.658-4.776.345-4.628 0 0 9.157.738 14.622.738 5.809 0 14.769-.738 14.769-.738 3.003-.148 3.397 4.234.394 4.578 0 0-3.003.345-6.4.542zM91.915 112a55.53 55.53 0 0027.618-48 55.31 55.31 0 00-6.794-26.634c.88 8.72-.44 17.522-3.84 25.6L91.914 112zM64 128A64.001 64.001 0 1164-.002 64.001 64.001 0 0164 128z"
    />
  </Icon>
);

export default WordpressLogo;
